import EcoliDropTarget from 'components/EcoliDropTarget';
import ExpressionResult from 'components/ExpressionResult';
import PredictionResult from 'components/PredictionResult';
import TestTubeRackPrediction from 'components/TestTubeRackPrediction';
import { observer } from 'mobx-react';
import React, { Component } from 'react';
import { IEcoli } from 'stores/models/Ecoli';
import ExpressionResultModel from 'stores/models/ExpressionResult';
import TestTubeRack from 'stores/models/TestTubeRack';
import { parseForTubes, parseOperons } from 'stores/services/ExpressionService';
import SectionHeader from './SectionHeader';

interface IProps {
  model?: IEcoli | null;
  isBlocked: boolean;
  onEcoliDropSuccess: () => void;
}

interface IState {
  expressionResult?: ExpressionResultModel | null;
  hasPrediction: boolean;
  vmEcoli?: IEcoli | null;
  vmTubesPrediction?: TestTubeRack | null;
  vmTubes?: TestTubeRack | null;
}

class View extends Component<IProps, IState> {
  defaultState: IState = {
    expressionResult: null,
    hasPrediction: false,
    vmEcoli: null,
    vmTubesPrediction: null,
    vmTubes: null,
  };
  refEcoliDropTarget: any = null;

  constructor(props: IProps) {
    super(props);

    this.state = this.defaultState;
  }

  private reset = () => {
    this.setState(this.defaultState);
    this.refEcoliDropTarget.reset();
  };

  private onDropSuccess = () => {
    const { model, onEcoliDropSuccess } = this.props;
    if (model) {
      const isCopyPlasmid = !!model?.plasmidDNA;
      const vmEcoli = model?.copy(isCopyPlasmid);
      const expressionResult: ExpressionResultModel = parseOperons(vmEcoli);
      const vmTubes = parseForTubes(expressionResult);

      this.setState({ expressionResult, vmEcoli, vmTubes });

      onEcoliDropSuccess();
    }
  };

  private onPredictionChange = (vmPrediction: TestTubeRack) => {
    this.setState({ hasPrediction: true, vmTubesPrediction: vmPrediction });
  };

  render() {
    const { isBlocked } = this.props;
    const {
      expressionResult,
      hasPrediction,
      vmEcoli,
      vmTubesPrediction: vmPrediction,
      vmTubes,
    } = this.state;
    const isDropReady = !isBlocked && !!vmEcoli;
    const prediction = vmPrediction?.isMatch(vmTubes);

    return (
      <div className='card is-flex is-flex-direction-column has-border-1 is-shadowless p-5 is-flex-grow-1 has-flex-basis-0'>
        <SectionHeader isDisabled={!isDropReady} step={3} onReset={this.reset}>
          <span className='has-text-grey is-size-7'>
            <span className='has-text-weight-semibold'>
              <span className='is-italic'>Drop</span> the E. coli instances then{' '}
              <span className='is-italic'>view</span> the expression
            </span>
            <br />
            <span className='has-text-grey-light'>
              Optionally <span className='is-italic'>predict</span> the four
              test tube reactions
            </span>
          </span>
        </SectionHeader>

        <div className='is-flex is-flex-grow-1 mb-2'>
          <div className='is-flex-centered mw-128px mr-4'>
            <div className='is-flex-centered'>
              <EcoliDropTarget
                ref={(el) => (this.refEcoliDropTarget = el)}
                model={isDropReady ? vmTubes : null}
                onDropSuccess={this.onDropSuccess}
              />
            </div>
          </div>
          <div className='is-flex pl-5 pr-5 is-flex-grow-1'>
            <div className='is-flex-centered'>
              <ExpressionResult model={isDropReady ? expressionResult : null} />
            </div>
          </div>
        </div>

        <div className='is-flex is-flex-grow-1'>
          <div className='is-flex-centered mw-128px mr-4'>
            <div className='is-flex-centered w-100p'>
              <TestTubeRackPrediction
                isPredicting={hasPrediction}
                onChange={this.onPredictionChange}
              />
            </div>
          </div>
          <div className='is-flex pl-5 is-flex-grow-1'>
            <div className='is-flex-centered'>
              <PredictionResult
                model={isDropReady ? expressionResult?.bacterial : null}
                prediction={prediction}
              />
            </div>
          </div>
        </div>
      </div>
    );
  }
}

const Section2 = observer(View);
export default Section2;
